/** Classify Soren cash utterances: navigate vs question vs Friday vs ask. */

export type CashIntent = 'navigate' | 'question' | 'friday' | 'ambiguous'

const NAV = /^(show me (my |the )?cash report|open ((the |my |company )?cash report)|go to (the |my )?cash report)\.?$/i
const FRIDAY = /^(friday check-?in|update forecast|start (the )?friday check-?in)\.?$/i
const QUESTION = /\?|^(am i|why|when|what|how|is |are |will |did |does )/i

export function classifyCashIntent(text: string): CashIntent {
  const t = String(text || '').trim()
  if (!t) return 'ambiguous'
  if (NAV.test(t)) return 'navigate'
  if (FRIDAY.test(t)) return 'friday'
  if (QUESTION.test(t) || /short|dip|pay|changed|runway|this week|next week/i.test(t)) {
    return 'question'
  }
  if (/cash report/i.test(t) && /(open|show|go)/i.test(t)) return 'navigate'
  if (/cash report/i.test(t)) return 'ambiguous'
  return 'question'
}
